import AnnotationIcon from "@assets/empty-annotation.svg";
import { css, useTheme } from "@emotion/react";
import { format } from "date-fns";
import { trpc } from "../../utils/trpc";
import { AnnotationView } from "../bits/Annotation";
import { FlexColContainer } from "../bits/layout";
import { LoadingSpinner } from "../bits/loading";
import { frjPublication } from "../bits/bookmarks/utils";

export const RecentAnnotations = () => {
  const theme = useTheme();
  const { data: annotations } = trpc.getAnnotations.useQuery(
    { total: 5 },
    {
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
  );

  const { data: publications, isLoading } = trpc.getPublications.useQuery();
  const { data: tags } = trpc.getTags.useQuery();

  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <FlexColContainer
          css={css`
            height: 100%;
            width: 100%;
            overflow-y: auto;
            padding: 22px 0px 12px 0px;
            gap: 12px;
          `}
        >
          {annotations?.length ? (
            annotations?.map((annotation) => {
              let publicationOrFRJ;
              const publication = publications?.find(
                (pub) => pub.id === annotation.publicationId,
              );
              if (publication) {
                publicationOrFRJ = publication;
              } else {
                if (annotation.articleSlug) {
                  publicationOrFRJ = frjPublication;
                }
              }
              return (
                <AnnotationView
                  annotation={{
                    ...annotation,
                    lastModified: new Date(annotation.lastModified),
                    createdAt: new Date(annotation.createdAt),
                  }}
                  key={annotation.id}
                  publication={publicationOrFRJ}
                  tags={tags}
                  label={`${publicationOrFRJ?.title ?? "Removed publication"} ● ${annotation.sectionTitle}
           ● ${new Date(annotation.lastModified).toLocaleTimeString("en-GB", {
             hour: "2-digit",
             minute: "2-digit",
           })} ● ${format(new Date(annotation.lastModified), "d MMMM")}`}
                />
              );
            })
          ) : (
            <FlexColContainer>
              <img
                src={AnnotationIcon}
                alt="No annotations"
                style={{
                  width: "100px",
                  height: "100px",
                  margin: "0 auto",
                  display: "block",
                  opacity: 0.5,
                }}
              />
              <p
                style={{
                  ...theme.customTypography.jumbo._5,
                  color: theme.colours.accent.mid.dark20,
                  textAlign: "center",
                }}
              >
                You haven't added any highlights or notes
              </p>
            </FlexColContainer>
          )}
        </FlexColContainer>
      )}
    </>
  );
};
